export default {"src":"/_next/static/media/stressMotivation.9c23d693.svg","height":644,"width":1048,"blurWidth":0,"blurHeight":0};